import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ValidationModel } from '../../shared/models/validation-results/validation.model';
import { NavigationService } from '../../shared/services/navigation/navigation.service';
import { HomemadeVehicleModel } from '../../vehicle/models/homemade-vehicle.model';
import { VehicleInformationModel } from '../../vehicle/models/vehicle-information.model';
import { VehicleModel } from '../../vehicle/models/vehicle.model';
import { VehiclePermitService } from '../../vehicle/services/vehicle-permit.service';
import { TransactionService } from './transaction.service';
import { WipDocumentService } from './wip-document.service';

@Injectable()
export class VehicleMediatorService {
    public vehicleInformationModel: VehicleInformationModel;
    public vehicleModel: VehicleModel;
    public homemadeVehicle: HomemadeVehicleModel;

    constructor(private navigationService: NavigationService, private wipDocumentService: WipDocumentService, private vehiclePermitService: VehiclePermitService, private transactionService: TransactionService) {

    }

    validateVehicle = (context: any): Observable<any> => {
        const errors = [];
        let validations$ = new Subject<any>();
        if (!context.navigationService.configurationValues['vehicleId'] && !context.wipDocumentService.hasWipDocument() && context.vehicleModel == null && context.homemadeVehicle == null) {
            errors.push({ errorMessage: 'Please select a vehicle to continue.' });
            var newErrors = new ValidationModel(errors);
            // behaviorsubject to assign prior to returning - no subscribe method.
            validations$ = new BehaviorSubject<any>(null);
            validations$.next(newErrors);
        } else if (context.homemadeVehicle != null) {
            context.vehiclePermitService.validateHommadeVehicle(context.homemadeVehicle)
                .subscribe(
                    r => {
                        validations$.next(r);
                    },
                    err => console.log(err),
                    () => {});
        } else if (context.navigationService.configurationValues['isSoldNotice']) {
            context.transactionService.validateTransaction(context.navigationService)
                .subscribe(r => {
                    validations$.next(r);
                },
                err => console.log(err),
                () => {});
        } else {
            // behaviorsubject to assign prior to returning - no subscribe method.
            validations$ = new BehaviorSubject<any>(null);
            var newErrors = new ValidationModel(errors);
            validations$.next(newErrors);
        }

        return validations$;
    };

}
